import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { loginAdmin } from '../services/firebase';
import { Input, Button, Spinner } from '../components/ui';
import logo from '../assets/logo_just_salento.png';
export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await loginAdmin(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(mapFirebaseError(err.code));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--navy)',
      backgroundImage: 'radial-gradient(ellipse at 70% 20%, rgba(31,147,224,0.08) 0%, transparent 60%)',
    }}>
      <div style={{ width: '100%', maxWidth: '400px', padding: '0 20px' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <img src={logo} alt="Just Salento" style={{ width: '200px', height: '200px' }} />
          <div style={{ fontFamily: 'var(--font-serif)', fontSize: '24px', marginTop: '12px' }}>
            Just Salento
          </div>
          <div style={{ fontSize: '12px', color: 'var(--text-muted)', letterSpacing: '0.1em', textTransform: 'uppercase', marginTop: '4px' }}>
            Pannello Gestione Lido
          </div>
        </div>

        {/* Card */}
        <div style={{
          background: 'var(--navy-mid)', border: '1px solid var(--border)',
          borderRadius: 'var(--radius-lg)', padding: '28px 28px',
        }}>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Input
              label="Email"
              type="email"
              placeholder="info@tuolido.it"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
            <Input
              label="Password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />

            {error && (
              <div style={{
                background: 'rgba(231,76,60,0.1)', border: '1px solid rgba(231,76,60,0.3)',
                borderRadius: 'var(--radius-md)', padding: '10px 12px',
                fontSize: '12.5px', color: '#f87171',
              }}>
                {error}
              </div>
            )}

            <Button type="submit" variant="primary" fullWidth disabled={loading} size="lg"
              style={{ marginTop: '4px' }}>
              {loading ? <Spinner size={16} /> : 'Accedi'}
            </Button>
          </form>

          <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '13px', color: 'var(--text-muted)' }}>
            Non hai un account?{' '}
            <Link to="/register" style={{ color: 'var(--ocean)', textDecoration: 'none' }}>
              Registra il tuo lido
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}


function mapFirebaseError(code) {
  const map = {
    'auth/user-not-found':    'Nessun account trovato con questa email.',
    'auth/wrong-password':    'Password errata. Riprova.',
    'auth/invalid-email':     'Indirizzo email non valido.',
    'auth/too-many-requests': 'Troppi tentativi. Riprova tra qualche minuto.',
    'auth/invalid-credential':'Email o password errati.',
  };
  return map[code] || 'Errore di accesso. Riprova.';
}
